import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { IKnowledgeArticleModel } from "../../../Services/KnowledgeArticleService";
import { KNOWLEDGE_BASE_LIST_PATH, resolveKnowledgeArticleIconClass } from "../../../Pages/KnowledgeBase/knowledgeBaseConstants";
import { isKnowledgeArticleRelationDisplayLink } from "../../../Pages/KnowledgeBase/knowledgeArticleRelationConstants";
import KnowledgeArticleEmbedDialog from "./KnowledgeArticleEmbedDialog";
import "./LinkedKnowledgeArticlesList.scss";

export interface LinkedKnowledgeArticlesListProps {
    articles: IKnowledgeArticleModel[];
}

/** Content-only list of clickable knowledge-article rows (icon, title, chevron) — no card/header chrome of
 *  its own, so a caller can drop it into whichever card/section shell that page already uses (e.g.
 *  AlertDetailSidebar's `detail-page-card`, MarketplaceDatasourceDetailPage's `marketplace-detail-card`).
 *  Dialog-mode rows embed the article; link-mode rows navigate to it. Renders nothing when empty. */
const LinkedKnowledgeArticlesList: React.FC<LinkedKnowledgeArticlesListProps> = ({ articles }) => {
    const navigate = useNavigate();
    const [embedArticle, setEmbedArticle] = useState<IKnowledgeArticleModel | null>(null);

    if (articles.length === 0) {
        return null;
    }

    return (
        <>
            <ul className="linked-knowledge-articles-list">
                {articles.map((article) => (
                    <li key={article.uuid}>
                        <button
                            type="button"
                            className="linked-knowledge-articles-list__item"
                            onClick={() => {
                                if (isKnowledgeArticleRelationDisplayLink(article.relationDisplayMode)) {
                                    navigate(`${KNOWLEDGE_BASE_LIST_PATH}/${article.uuid}`);
                                    return;
                                }
                                setEmbedArticle(article);
                            }}
                        >
                            <i className={resolveKnowledgeArticleIconClass(article.icon)} />
                            <span>{article.title}</span>
                            <i
                                className={
                                    isKnowledgeArticleRelationDisplayLink(article.relationDisplayMode)
                                        ? "pi pi-external-link linked-knowledge-articles-list__chevron"
                                        : "pi pi-clone linked-knowledge-articles-list__chevron"
                                }
                            />
                        </button>
                    </li>
                ))}
            </ul>
            <KnowledgeArticleEmbedDialog
                articleUuid={embedArticle?.uuid ?? null}
                sectionIdentifiers={embedArticle?.relationSectionIdentifiers}
                onHide={() => setEmbedArticle(null)}
            />
        </>
    );
};

export default LinkedKnowledgeArticlesList;
